module.exports = __webpack_public_path__ + "img/sponsor.b84c5091.svg";